var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('ProjectList',{attrs:{"metas":_vm.metas,"listItems":_vm.items,"ems":_vm.ems,"showProjectFilter":_vm.clonedItems.length > 0}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }